import axios from 'axios'

const server = 'http://jiananzb.w11-e1.ezwebtest.com/cannan_api/api'

const front = {
  state: {
    userInfo: [],
    announce: [],
    // 基金
    fundInfo: [],
    saleFundInfo: [],
    catelog: [],
    hire: [],
    // 圖表
    fundInfoChart: [],
    saleFundInfoChart: [],
    // 人員
    fundMemberInfo: [],
    saleMemberInfo: [],
    // 公司
    fundCompany: [],
    saleCompany: [],
    // 公告
    announceByUser: [],
    // 海外資產運營第三級
    hotelDetail: [],
    // 註冊
    registerData: [],
    verifyData: [],
    recover: [],
    recoverPassword: [],
    updatePassword: [],
    isLogin: false
  },
  mutations: {
    isLogin(state, data) {
      state.isLogin = data
    },
    GET_USER_INFO(state, data) {
      state.userInfo = data
    },
    GET_ANNOUNCE(state, data) {
      state.announce = data
    },
    // 基金
    GET_FUND_INFO(state, data) {
      state.fundInfo = data
    },
    GET_SALE_FUND_INFO(state, data) {
      state.saleFundInfo = data
    },

    GET_CATELOG(state, data) {
      state.catelog = data
    },
    GET_HIRE_DATA(state, data) {
      state.hire = data
    },
    // 圖表
    GET_FUND_INFO_CHART(state, data) {
      state.fundInfoChart = data
    },
    GET_SALE_FUND_INFO_CHART(state, data) {
      state.saleFundInfoChart = data
    },
    // 人員
    GET_FUND_MEMBER_INFO(state, data) {
      state.fundMemberInfo = data
    },
    GET_SALE_MEMBER_INFO(state, data) {
      state.saleMemberInfo = data
    },
    // 公司
    GET_FUND_COMPANY(state, data) {
      state.fundCompany = data
    },
    GET_SALE_COMPANY(state, data) {
      state.saleCompany = data
    },
    // 公告
    GET_ANNOUNCE_BY_USER(state, data) {
      state.announceByUser = data
    },
    // 海外資產運營第三級
    GET_HOTEL_DETAIL(state, data) {
      state.hotelDetail = data
    },
    MEMBER_REGISTER(state, data) {
      state.registerData = data
    },
    MEMBER_VERIFY(state, data) {
      state.verifyData = data
    },
    RECOVER(state, data) {
      state.recover = data
    },
    RECOVER_PASSWORD(state, data) {
      state.recoverPassword = data
    },
    UPDATE_PASSWORD(state, data) {
      state.updatePassword = data
    },
  },
  actions: {
    MemberRegister(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/sale/register`, data).then((response) => {
          context.commit('MEMBER_REGISTER', response.data)
          resolve()
        })
      })
    },
    MemberVerify(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/sale/verify`, data).then((response) => {
          context.commit('MEMBER_VERIFY', response.data)
          resolve()
        })
      })
    },
    Recover(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/sale/recover`, data).then((response) => {
          context.commit('RECOVER', response.data)
          resolve()
        })
      })
    },
    RecoverPassword(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/sale/recoverPassword`, data).then((response) => {
          context.commit('RECOVER_PASSWORD', response.data)
          resolve()
        })
      })
    },
    UpdatePassword(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/sale/updatePassword`, data).then((response) => {
          context.commit('UPDATE_PASSWORD', response.data)
          resolve()
        })
      })
    },
    MemberLogin(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/sale/memberLogin`, data).then((response) => {
          context.commit('GET_USER_INFO', response.data)
          resolve()
        })
      })
    },
    GetAnnounce(context) {
      return new Promise((resolve) => {
        axios.get(`${server}/front/announce`).then((response) => {
          context.commit('GET_ANNOUNCE', response.data)
          resolve()
        })
      })
    },

    GetFundInfoByUser(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/front/getFundInfoByUser`, data).then((response) => {
          context.commit('GET_FUND_INFO', response.data)
          resolve()
        })
      })
    },
    // 基金
    GetSaleFundInfoByUser(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/front/getSaleFundInfoByUser`, data).then((response) => {
          context.commit('GET_SALE_FUND_INFO', response.data)
          resolve()
        })
      })
    },
    GetCatelog(context) {
      return new Promise((resolve) => {
        axios.get(`${server}/front/catelog`).then((response) => {
          context.commit('GET_CATELOG', response.data)
          resolve()
        })
      })
    },
    GetHireData(context) {
      return new Promise((resolve) => {
        axios.get(`${server}/front/hire`).then((response) => {
          context.commit('GET_HIRE_DATA', response.data)
          resolve()
        })
      })
    },
    // 圖表
    GetFundInfoChart(context, data) {
      return new Promise((resolve) => {
        axios.get(`${server}/fund/fundInfo/${data}`).then((response) => {
          const data = response.data.data
          context.commit('GET_FUND_INFO_CHART', data)
          resolve()
        })
      })
    },
    GetSaleFundInfoChart(context, data) {
      return new Promise((resolve) => {
        axios.get(`${server}/sale/saleFundInfo/${data}`).then((response) => {
          const data = response.data.data
          context.commit('GET_SALE_FUND_INFO_CHART', data)
          resolve()
        })
      })
    },
    // 人員
    GetFundMemberInfo(context, data) {
      return new Promise((resolve) => {
        axios.get(`${server}/fund/fundMemberInfo/${data}`).then((response) => {
          const data = response.data.data
          context.commit('GET_FUND_MEMBER_INFO', data)
          resolve()
        })
      })
    },
    GetSaleMemberInfo(context, data) {
      return new Promise((resolve) => {
        axios.get(`${server}/sale/saleMemberInfo/${data}`).then((response) => {
          const data = response.data.data
          context.commit('GET_SALE_MEMBER_INFO', data)
          resolve()
        })
      })
    },
    // 公司
    GetFundCompany(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/front/getFundInfoByCompany/`, {
          company_id: data
        }).then((response) => {
          const data = response.data.data
          context.commit('GET_FUND_COMPANY', data)
          resolve()
        })
      })
    },
    GetSaleCompany(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/front/getSaleFundInfoByCompany/`, {
          sale_company_id: data
        }).then((response) => {
          const data = response.data.data
          context.commit('GET_SALE_COMPANY', data)
          resolve()
        })
      })
    },
    // 公告
    GetAnnounceByUser(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/front/getAnnounceByUser`, data).then((response) => {
          const data = response.data.data
          context.commit('GET_ANNOUNCE_BY_USER', data)
          resolve()
        })
      })
    },
    // 海外資產運營第三級
    GetHotelDetail(context) {
      return new Promise((resolve) => {
        axios.get(`${server}/front/hotelDetail`).then((response) => {
          const data = response.data.data
          context.commit('GET_HOTEL_DETAIL', data)
          resolve()
        })
      })
    }
  }
}
export default front
